import { AirportCodes } from '../types/airports';

export const isStringTranslatable = (word: string) => {
	// These airport codes should not get translated
	const airportCodes = [
		AirportCodes.IAH,
		AirportCodes.HOU,
		AirportCodes.EFD,
		'HAS',
	];
	const isAirportCode = Object.values(airportCodes).some((code) =>
		word.toLowerCase().includes(code.toLowerCase()),
	);

	return !isAirportCode;
};
